module.exports = ".tether-element, .tether-element:after, .tether-element:before, .tether-element *, .tether-element *:after, .tether-element *:before {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box; }\n\n.tether-element {\n  position: absolute;\n  display: none; }\n\n.tether-element.tether-open {\n    display: block; }\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./node_modules/tether/dist/css/tether.css
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./node_modules/tether/dist/css/tether.css
// module chunks = styles